module.exports = __webpack_public_path__ + "media/images/lesson_7/sebastiao_ponte-ae0882c32b3e36db885d3f8b2d557786.png";